module.exports = __webpack_public_path__ + "img/74400.1667d6ff.jpg";